$(document).ready(function(){

  $("a.search-icon").click(function(){
    $(".search.m-search").fadeToggle();
  })

  $(".template-search .product-grid").prop('id', 'product-grid');
  setTimeout(function(){
    $("summary.facets__summary.caption-large.focus-offset").click();
  }, 100)

  $(".tpo_image-swatches-wrapper").click(function(){
    
    $(".tpo_image-swatches-wrapper").removeClass("active");
    $(this).addClass("active");
  })
  
  $(".nav-toggle").click(function(){
    $(".mobile-menu").toggleClass("show");
  })
  $("#close_nav").click(function(){
    $(".mobile-menu").removeClass("show");
  })

    $('.product-carousel, .related-products-slider').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      speed: 500,
      autoplay: false,
      autoplaySpeed: 3000,
      centerMode: false, // set to true if you want a centered effect
      prevArrow: '<button type="button" class="slick-prev custom-arrow" id="product_left"><img src="https://cdn.shopify.com/s/files/1/0910/9549/9056/files/Vector_4.svg?v=1745487309" alt="Previous" /></button>',
      nextArrow: '<button type="button" class="slick-next custom-arrow" id="product_right"><img src="https://cdn.shopify.com/s/files/1/0910/9549/9056/files/Vector_4.svg?v=1745487309" alt="Next" /></button>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            arrows: true,
            dots: false,
            fade: false
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            arrows: true,
            dots: false,
            fade: false
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            arrows: true,
            dots: false,
            fade: false
          }
        }
      ]
    });

    $('.insta-slider').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      autoplay: true,
      autoplaySpeed: 3000,
      responsive: [
        {
          breakpoint: 1024,
          settings: { slidesToShow: 3 }
        },
        {
          breakpoint: 768,
          settings: { slidesToShow: 2 }
        },
        {
          breakpoint: 480,
          settings: { slidesToShow: 1 }
        }
      ]
    });

    $('.promo-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      autoplay: true,
      autoplaySpeed: 5000,
      infinite: false, // 👈 Disable cloning
      responsive: [
        {
          breakpoint: 1024,
          settings: { slidesToShow: 1 }
        },
        {
          breakpoint: 768,
          settings: { slidesToShow: 1 }
        },
        {
          breakpoint: 480,
          settings: { slidesToShow: 1 }
        }
      ]
    });

  setTimeout(function(){
    $("p.message").hide();
  }, 2000)

  if ($(window).width() <= 768) { // 768px is a common mobile breakpoint
    $(".footer_main h4.font-bold").click(function () {
      $($(this).attr('data')).slideToggle();
    });
  }

  $('.team-slider').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      speed: 500,
      autoplay: false,
      autoplaySpeed: 3000,
      centerMode: false, // set to true if you want a centered effect
      prevArrow: '<button type="button" class="slick-prev custom-arrow" id="product_left"><img src="https://cdn.shopify.com/s/files/1/0910/9549/9056/files/Vector_4.svg?v=1745487309" alt="Previous" /></button>',
      nextArrow: '<button type="button" class="slick-next custom-arrow" id="product_right"><img src="https://cdn.shopify.com/s/files/1/0910/9549/9056/files/Vector_4.svg?v=1745487309" alt="Next" /></button>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            arrows: true,
            dots: false,
            fade: false
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            arrows: true,
            dots: false,
            fade: false
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            arrows: true,
            dots: false,
            fade: false
          }
        }
      ]
    });

    $('li.relative.group > i.fa.fa-angle-down').on('click', function(e) {
        e.preventDefault();
        
        // Find the closest `ul.mobile_sub_menu` and toggle the class
        $(this).next().toggleClass('show');
    });

    $('.back_arrow').on('click', function(e) {
        e.preventDefault();
        $(this).closest('ul.mobile_sub_menu').removeClass('show');
    });

    $("button.close-cart").click(function(){
      $("#cart-drawer").removeClass("show");
    })

    $(".show-cart").click(function(){
      $("#cart-drawer").addClass("show");
      return false;
    })
})